import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { UsersComponent } from './pages/users/users.component';
import { CompaniesComponent } from './pages/companies/companies.component';
import { NewUserComponent } from './pages/new-user/new-user.component';
import { EditUserComponent } from './pages/edit-user/edit-user.component';
import { NewCompanyComponent } from './pages/new-company/new-company.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { DocumentsComponent } from './pages/documents/documents.component';
import { NewDocumentComponent } from './pages/new-document/new-document.component';
import { EditDocumentComponent } from './pages/edit-document/edit-document.component';
import { EditCompanyComponent } from './pages/edit-company/edit-company.component';
import { DocumentsTypeComponent } from './pages/documents-type/documents-type.component';
import { SegmentsComponent } from './pages/segments/segments.component';
import { ActivitiesComponent } from './pages/activities/activities.component';
import { BiddingsComponent } from './pages/biddings/biddings.component';
import { BiddingsReportComponent } from './pages/biddings-report/biddings-report.component';
import { ActivitiesReportComponent } from './pages/activities-report/activities-report.component';
import { PartnersComponent } from './pages/partners/partners.component';
import { NewPartnerComponent } from './pages/new-partner/new-partner.component';
import { EditPartnerComponent } from './pages/edit-partner/edit-partner.component';
import { PartnersReportComponent } from './pages/partners-report/partners-report.component';
import { CustomersReportComponent } from './pages/customers-report/customers-report.component';
import { CompanyReportComponent } from './pages/company-report/company-report.component';
import { IndicationsComponent } from './pages/indications/indications.component';
import { SalesFunnelReportComponent } from './pages/sales-funnel-report/sales-funnel-report.component';
import { BudgetReportComponent } from './pages/budget-report/budget-report.component';
import { ExcelReportComponent } from './pages/excel-report/excel-report.component';
import { NewBiddingsComponent } from './pages/new-biddings/new-biddings.component';

export const routes: Routes = [
    {
      path: '',
      component: HomeComponent
    },
    {
      path: 'login',
      component: LoginComponent
    },
    {
      path: 'home',
      component: HomeComponent
    }
    ,
    {
      path: 'usuarios',
      component: UsersComponent
    }
    ,
    {
      path: 'usuarios/novo',
      component: NewUserComponent
    }
    ,
    {
      path: 'empresas',
      component: CompaniesComponent
    }
    ,
    {
      path: 'empresas/novo',
      component: NewCompanyComponent
    }
    ,
    {
      path: 'usuarios/edit/:id',
      component: EditUserComponent
    }
    ,
    {
      path: 'forgot-password',
      component: ForgotPasswordComponent
    }
    ,
    {
      path: 'contacts/:id',
      component: ContactsComponent
    }
    ,
    {
      path: 'documentos',
      component: DocumentsComponent
    }
    ,
    {
      path: 'documentos/novo',
      component: NewDocumentComponent
    }
    ,
    {
      path: 'documentos/edit/:id',
      component: EditDocumentComponent
    }
    ,
    {
      path: 'empresas/edit/:id',
      component: EditCompanyComponent
    }
    ,
    {
      path: 'categorias-documentos',
      component: DocumentsTypeComponent
    }
    ,
    {
      path: 'segmentos',
      component: SegmentsComponent
    },
    {
      path: 'atividades',
      component: ActivitiesComponent
    },
    {
      path: 'licitacoes',
      component: BiddingsComponent
    }
    ,
    {
      path: 'parceiros',
      component: PartnersComponent
    }
    ,
    {
      path: 'parceiros/novo',
      component: NewPartnerComponent
    }
    ,
    {
      path: 'parceiros/edit/:id',
      component: EditPartnerComponent
    }
    ,
    {
      path: 'relatorio-de-licitacoes',
      component: BiddingsReportComponent
    },
    {
      path: 'relatorio-de-atividades',
      component: ActivitiesReportComponent
    },
    {
      path: 'relatorio-de-parceiros',
      component: PartnersReportComponent
    },
    {
      path: 'relatorio-de-clientes',
      component: CustomersReportComponent
    },
    {
      path: 'relatorio-de-empresa',
      component: CompanyReportComponent
    },
    {
      path: 'indicacoes',
      component: IndicationsComponent
    },
    {
      path: 'relatorio-de-funil-de-vendas',
      component: SalesFunnelReportComponent
    },
    {
      path: 'relatorio-de-orcamento',
      component: BudgetReportComponent
    },
    {
      path: 'relatorios-licitacoes-vencidas',
      component: ExcelReportComponent
    },
    {
      path: 'relatorios-licitacoes-perdidas',
      component: ExcelReportComponent
    },
    {
      path: 'import-biding',
      component: NewBiddingsComponent
    }
  ];

  export const partialComponents = [
    LoginComponent,
  ];



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts